import React, { useState } from 'react';

export type AgentDotState = 'disabled' | 'enabled' | 'proactive' | 'unknown';

interface AgentStatusDotProps {
  state: AgentDotState;
  size?: number;
}

const STATES: Record<AgentDotState, { color: string; shadow: string; label: string; description: string }> = {
  disabled: {
    color: '#9ca3af',
    shadow: 'rgba(156,163,175,0.25)',
    label: 'Agente deshabilitado',
    description: 'El agente no está habilitado para este paciente.',
  },
  enabled: {
    color: '#f59e0b',
    shadow: 'rgba(245,158,11,0.25)',
    label: 'Agente habilitado, proactivo deshabilitado',
    description: 'El chat puede ejecutar acciones, pero el sistema no enviará mensajes proactivos.',
  },
  proactive: {
    color: '#10b981',
    shadow: 'rgba(16,185,129,0.25)',
    label: 'Agente habilitado y proactivo',
    description: 'El chat ejecuta acciones y el sistema puede enviar mensajes proactivos al paciente.',
  },
  unknown: {
    color: '#e5e7eb',
    shadow: 'rgba(229,231,235,0.4)',
    label: 'Estado desconocido',
    description: 'No se pudo cargar la configuración del agente.',
  },
};

const AgentStatusDot: React.FC<AgentStatusDotProps> = ({ state, size = 10 }) => {
  const [hover, setHover] = useState(false);
  const s = STATES[state];

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <span
        aria-label={s.label}
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          background: s.color,
          boxShadow: `0 0 0 3px ${s.shadow}`,
        }}
      />
      {hover && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            bottom: `calc(100% + 8px)`,
            left: '50%',
            transform: 'translateX(-50%)',
            background: '#1f2937',
            color: '#fff',
            fontSize: 12,
            lineHeight: 1.4,
            padding: '8px 10px',
            borderRadius: 6,
            whiteSpace: 'normal',
            width: 220,
            boxShadow: '0 4px 12px rgba(0,0,0,0.18)',
            zIndex: 50,
            pointerEvents: 'none',
          }}
        >
          <div style={{ fontWeight: 600, marginBottom: 2 }}>{s.label}</div>
          <div style={{ opacity: 0.85 }}>{s.description}</div>
        </span>
      )}
    </span>
  );
};

export const computeAgentDotState = (cfg: { enabled: boolean; proactive_enabled: boolean } | null | undefined): AgentDotState => {
  if (!cfg) return 'unknown';
  if (!cfg.enabled) return 'disabled';
  if (!cfg.proactive_enabled) return 'enabled';
  return 'proactive';
};

export default AgentStatusDot;
